import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { VertiLoginFailure, VertiLoginRequest, VertiLoginSuccess } from './actions';
import { VertiLoginService } from './service';
import { UpdateRtkJwt, UpdateTkJwt } from '@store/flow-data/general';

@Injectable()
export class VertiLoginEffects {
  private readonly actions$ = inject(Actions);
  private readonly vertiLoginService = inject(VertiLoginService);

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VertiLoginRequest),
      switchMap(({ body, parameters }) =>
        this.vertiLoginService.vertiLogin(body, parameters).pipe(
          switchMap(data => [
            UpdateTkJwt({ data: data.token }),
            UpdateRtkJwt({ data: data.refreshToken }),
            VertiLoginSuccess({ data }),
          ]),
          catchError(error => of(VertiLoginFailure({ error })))
        )
      )
    )
  );

}
